<div class="modal-header">
    <div class="row col-12">
        <div class="modal-title col-10">
            <h4>Aktiver synkroniseringskontrakt</h4>
        </div>
        <div class="text-end col-2">
            <button type="button" class="btn" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
                <span aria-hidden="true"><i class="fa-solid fa-x"></i></span>
            </button>
        </div>
    </div>
</div>

<div class="modal-body col-12 vh-25">

    @if (activateSync == true)
    {
    <div class="d-flex flex-column justify-content-center align-items-center w-100 vh-25">
        <div class="continuous-loader" role="status"></div>
        <h4 class="mt-2">Aktiver synkroniseringen..</h4>
    </div>
    }
    @else {

    <div class="row">
        <div class="row mb-3">
            <div class="form-floating col-lg-12 col-12 mb-lg-12 mb-3">
                <input type="text" class="form-control" id="synchronization-name" [(ngModel)]="externalkey"
                    name="syncnavn" autocomplete="off" autofocus required="true">
                <label class="ms-2" for="customer-name">ekstern nøgle (min. 10 tegn)</label>
            </div>
        </div>
    </div>
    <div class="modal-footer bg-transparent">
        <button class="btn btn-success float-end" [disabled]="! canActivate()" (click)="activateSyncronization()">Aktiver synkroniseringskontrakt</button>
    </div>
    }
</div>